module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.taskCategory.title))]), _vm._v(" "), _c('td', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        animateFill: false,
        animation: 'shift-away',
        onShow: function () { return _vm.isDateIntervalChanged; }
      }),
      expression: "{\n        animateFill: false,\n        animation : 'shift-away',\n      onShow: () => isDateIntervalChanged\n    }"
    }],
    staticClass: "is-number",
    class: {
      'is-number--calculated': _vm.isDateIntervalChanged
    },
    attrs: {
      "content": _vm.schoolTooltipContent
    }
  }, [(_vm.isDateIntervalChanged) ? _c('span', {
    staticClass: "icon-clock"
  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.sumOfHours) + "\n  ")]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.sumOfActual))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
    staticClass: "is-number"
  }, [_vm._v("\n    " + _vm._s(_vm.sumOfDiff) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b1d9e9c8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/UserTasksOverviewOwnPoolsPool.vue
// module id = 2096
// module chunks = 1